/**
 * Returns the correct series IDs based on whether the app
 * is running on a staging URL (contains "manningtonstaging").
 */

const isStaging = window.location.href.includes("manningtonstaging");

export const SERIES_IDS = {
  carpet: isStaging ? 9770 : 8639,
  lvt: isStaging ? 9771 : 8645,
  broadloom: isStaging ? 9773 : 9743,
  heterogeneous: 8644,
  homogeneous: 8643,
  installMethods: 9774,
  wallColors: 7973,
};
